import React from 'react'
import {Routes, Route} from 'react-router-dom'
import Contact from './routes/Contact';
import Home from './routes/Home'
import Pricing from './routes/Pricing'
import Training from './routes/Training';
import Sponsor from './routes/Sponsor';
import GeneralDel from './routes/General';
import MineOwn from './routes/MineOwner';
import Investor from './routes/Investor';
import Machinery from './routes/Machinery';
import Commodity from './routes/Commodity';
import Smelter from './routes/Smelter';
import Terms from './routes/Terms';
import Segmented from './routes/Segmented';


function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/pricing' element={<Pricing />} />
        <Route path='/training' element={<Training />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/sponsor' element={<Sponsor />} />
        <Route path="/general-delegate" element={<GeneralDel />} />
        <Route path="/mine-owner" element={<MineOwn />} />
        <Route path="/investor" element={<Investor />} />
        <Route path="/csi" element={<Segmented />} />
        <Route path="/machinery-supplier" element={<Machinery />} />
        <Route path="/commodity-direct-buyer" element={<Commodity />} />
        <Route path="/direct-smelter" element={<Smelter />} />
        <Route path="/terms-and-conditions" element={<Terms />} />
      </Routes>
    </>
  );
}

export default App;
